// todo: figure out where this should really live
import THDCustomer from '@thd-olt-global/thd-customer';

export const isLoggedIn = () => {
  try {
    const loggedIn = THDCustomer?.isLoggedIn;
    return loggedIn;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }
  return false;
};

export const updateQueryParams = (path, params) => {
  const paramNames = params.map((p) => p.paramName); // eslint-disable-line id-length

  const [pathname, query = ''] = path.split('?');
  const queryParams = query.split('&').filter((p) => p); // eslint-disable-line id-length
  const updatedParams = [
    ...queryParams
      .filter((queryParam) => {
        const parts = queryParam.split('=');
        return paramNames.indexOf(parts[0]) === -1;
      }),
    ...params
      .filter((p) => p.paramValue) // eslint-disable-line id-length
      .map((param) => {
        return `${param.paramName}=${param.paramValue}`;
      })
  ].join('&');
  return pathname + '?' + updatedParams;
};